import {CensusFilterModel} from "../../models/FormDataModel"
import {  SET_SELECTED_LOCATIONS, RESET_FILTER,  SELECTED_DATE, SET_FILTER,  INITIALIZE_DEFAULTS, SET_DEFAULT_EXPANDED_KEYS } from "../actions/CensusAction";

const initialState = { 
    filter: CensusFilterModel,
    isFilterApplied: false, 
    defaultExpandedKeys:{}   
}
const CensusReducer = (state = initialState, action)=>{
  
    switch(action.type){
        case INITIALIZE_DEFAULTS:
            return {...state, filter:{...state.filter, date: action.defaults.date, selectedLocations:action.defaults.selectedLocations}}
        case SET_DEFAULT_EXPANDED_KEYS:
            return {...state, defaultExpandedKeys:action.expandedKeys}
        case SET_SELECTED_LOCATIONS: 
            return {...state, filter: {...state.filter, selectedLocations:action.selectedLocations}}  
        case SELECTED_DATE:
            return {...state, filter: {...state.filter, date:action.date}}
        case SET_FILTER:
        return {...state, isFilterApplied: true, filter: {...state.filter, bedStatus:action.filter.bedStatus, bedType:action.filter.bedType, program: action.filter.program,
            bedMngmtStaffDetails: action.filter.bedMngmtStaffDetails, bedTags: action.filter.bedTags,
            occupancyStatus:action.filter.occupancyStatus, reservationStatus: action.filter.reservationStatus, activeStatus: action.filter.activeStatus}}
        case RESET_FILTER:
            return {...state,isFilterApplied: false, filter: {...state.filter, bedStatus:null, bedType:null, program: null,
                bedMngmtStaffDetails: null, bedTags: null, occupancyStatus: null, reservationStatus: null, activeStatus: null}}
       
        default:
            return {...state}           
    }

}

export default CensusReducer;